import { createPortal } from 'react-dom';

import { getSubmenuId } from '../lib/getSubmenuAriaProps';
import { handleSubmenuPositioning } from '../../Panel/lib/subPanelPosition';
import { focusFirstMenuItem, handleSubmenuKeyDown } from '../../../lib/menuKeyboard';

// Portaled to body so it escapes the panel's scroll/overflow. Starts as fixed+hidden so
// shrink-to-fit width is correct before we measure; handleSubmenuPositioning sets top/left
// and clears visibility.
const PopoverSubmenu = ({
  submenuKey,
  submenuRefs,
  anchorRef,
  focusOnOpenRef,
  position,
  optionPosition,
  onMouseEnter,
  onMouseLeave,
  onClose,
  children
}) =>
  createPortal(
    <div
      id={getSubmenuId(submenuKey)}
      role="menu"
      ref={(node) => {
        handleSubmenuPositioning(node, submenuKey, submenuRefs, anchorRef, {
          position,
          optionPosition
        });
        // Queued after the positioning timeout, which is what makes the submenu visible.
        if (node && focusOnOpenRef.current) {
          focusOnOpenRef.current = false;
          setTimeout(() => focusFirstMenuItem(node), 0);
        }
      }}
      onKeyDown={(event) => handleSubmenuKeyDown(event, anchorRef.current, onClose)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ position: 'fixed', top: 0, left: 0, visibility: 'hidden' }}
      className="z-[101] grid min-w-[120px] rounded-md bg-white py-2 shadow-[0px_2px_16px_0px_rgba(0,79,107,0.2)]">
      {children}
    </div>,
    document.body
  );

export default PopoverSubmenu;
